import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Badge, Col, Card, CardBody, Row, Button } from 'reactstrap';
import Api from '../../config/Api';
import { REST_KEY } from '../../config/config';

export default class CardSlider extends Component {
	state = {
		kategori: '',
		token_api: REST_KEY,
	};
	listSlider = async () => {
		await Api.post('profildesa/listslider', this.state).then((res) => {
			let s = res.data;
			if (s.status) {
				this.setState({
					status: s.status,
					message: s.pesan,
					indicator: s.indicator,
					icon: s.icon,
					slider: s.data,
					redirect: true,
					loading: false,
				});
			} else {
				console.log(s);
			}
		});
	};
	componentDidMount() {
		this.listSlider();
	}
	render() {
		let CardSlider = '';
		if (this.state.status) {
			CardSlider = this.state.slider.map((data, key) => {
				return (
					<Col lg="4" key={key}>
						<Card
							className="card-lift--hover shadow border-0"
							style={{
								height: '100%',
							}}
						>
							<CardBody className="py-3">
								<div className="icon icon-shape icon-shape-primary rounded-circle mb-1">
									<i className="fa fa-home" />
								</div>
								<h6 className="text-primary text-uppercase text-center">Hari Pancasila</h6>
								<div>
									<img alt="..." className="img-center img-fluid" src={data.foto} style={{}} />
								</div>
								<div>
									<Badge color="primary" pill className="mr-1">
										Edit
									</Badge>
									<Badge color="primary" pill className="mr-1">
										system
									</Badge>
									<Badge color="primary" pill className="mr-1">
										Delete
									</Badge>
								</div>
							</CardBody>
						</Card>
					</Col>
				);
			});
		}
		return (
			<Container>
				<Link to={'/admin/tambah-slider'}>
					<Button className="btn-icon btn-2 mb-2" color="success" type="button">
						<span className="btn-inner--icon">
							<i className="fa fa-plus fa-2x" />
						</span>
					</Button>
				</Link>
				<Row className="justify-content-center row-grid">{CardSlider}</Row>
			</Container>
		);
	}
}
